<template>

  <div>
    <Panel class="p-col-12 p-mt-2" header="Profil" :toggleable="false">
      <template #icons>

        <Button @click="openPwDialog" label="Passwort ändern" class="p-button-link p-mr-2"/>
        <Button @click="openEditDialog" label="Daten ändern" class="p-button-link p-mr-2"/>

      </template>

      <!-- Normal device -->
      <div class="p-grid" v-responsive.md.lg.xl>
        <div :v-if="user" class="p-col-4">
          <img :src="user.url" class="profile-avatar" />
        </div>
        <div class="p-col-6">
          <div class="p-grid">
            <div class="p-col-4">
              <strong>Benutzername:</strong>
            </div>
            <div class="p-col-6">
              {{ user.username }}
            </div>
          </div>

          <div class="p-grid">
            <div class="p-col-4">
              <strong>Name:</strong>
            </div>
            <div class="p-col-6">
              {{ user.name }} {{ user.surname }}
            </div>
          </div>

          <div class="p-grid">
            <div class="p-col-4">
              <strong>Adresse:</strong>
            </div>
            <div class="p-col-6">
              {{ user.street }}
            </div>
          </div>
          <div class="p-grid">
            <div class="p-col-6 p-offset-4">
              {{ user.zipCode }} {{ user.city }}
            </div>
          </div>
          <div class="p-grid">
            <div class="p-col-4">
              <strong>Tel.:</strong>
            </div>
            <div class="p-col-6">
              {{ user.phone }}
            </div>
          </div>

          <div class="p-grid">
            <div class="p-col-4">
              <strong>Email:</strong>
            </div>
            <div class="p-col-6">
              {{ user.email }}
            </div>
          </div>

        </div>
      </div>

      <!-- Small device -->
      <div class="p-grid" v-responsive.sm.xs>
        <div :v-if="user" class="p-col-12">
          <img :src="user.url" class="profile-avatar" />
        </div>
        <div class="p-col-12">
          <div class="p-grid">
            <div class="p-col-4">
              <strong>Benutzername:</strong>
            </div>
            <div class="p-col-6">
              {{ user.username }}
            </div>
          </div>

          <div class="p-grid">
            <div class="p-col-4">
              <strong>Name:</strong>
            </div>
            <div class="p-col-6">
              {{ user.name }} {{ user.surname }}
            </div>
          </div>

          <div class="p-grid">
            <div class="p-col-4">
              <strong>Adresse:</strong>
            </div>
            <div class="p-col-6">
              {{ user.street }}
            </div>
          </div>
          <div class="p-grid">
            <div class="p-col-6 p-offset-4">
              {{ user.zipCode }} {{ user.city }}
            </div>
          </div>
          <div class="p-grid">
            <div class="p-col-4">
              <strong>Tel.:</strong>
            </div>
            <div class="p-col-6">
              {{ user.phone }}
            </div>
          </div>

          <div class="p-grid">
            <div class="p-col-4">
              <strong>Email:</strong>
            </div>
            <div class="p-col-6">
              {{ user.email }}
            </div>
          </div>

        </div>
      </div>

      <strong v-if=isAdmin>Rollen:</strong>
      <ul v-if=isAdmin>
        <li v-for="(role,index) in currentUser.roles" :key="index">{{ role }}</li>
      </ul>

    </Panel>

    <Dialog header="Ändere dein Passwort" :visible.sync="displayDialog" :modal="true">

      <div class="p-grid">
        <div class="p-col-4">
          <strong>Altes Passwort:</strong>
        </div>
        <div class="p-col-6">
          <Password v-model="current" :feedback="false"></Password>
        </div>

      </div>
      <div class="p-grid">
        <div class="p-col-4">
          <strong>Neues Passwort:</strong>
        </div>
        <div class="p-col-6">
          <Password v-model="changeTo"></Password>
        </div>

      </div>
      <div class="p-grid">
        <div class="p-col-4">
          <strong>Wiederhole Passwort:</strong>
        </div>
        <div class="p-col-6">
          <Password v-model="repeatChangeTo" :feedback="false"></Password>
        </div>

      </div>

      <div class="p-grid">
        <Message v-if="!hideMessage" :closable="false" severity="error" :key="message">{{ message }}</Message>
      </div>

      <template #footer>
        <div v-if="!showResult">
          <Button @click="closePwDialog" label="Abbrechen" icon="pi pi-times" class="p-button-text"/>
          <Button @click="changePw" label="Speichern" icon="pi pi-check"/>
        </div>
        <div v-else>
          <Message :closable="false" :severity="resultMsg.severity" :key="resultMsg.severity">{{ resultMsg.message }}
          </Message>
        </div>
      </template>
    </Dialog>

    <Dialog header="Benutzerdaten ändern" :visible.sync="showEdit" :modal="true">
      <UserEdit @close-dialog="closeDialog" :selected-user-prop="currentUser"></UserEdit>
    </Dialog>

  </div>

</template>

<script>
import UserService from '../services/user.service';
import UserEdit from "@/components/UserEdit";

export default {
  name: 'Profile',
  components: {UserEdit},
  props: {
    repeatPasswordProp: {
      Type: String,
      default: ''
    }
  },
  data() {
    return {
      user: {
        id: null,
        username: '',
        email: '',
        name: '',
        surname: '',
        street: '',
        zipCode: '',
        city: '',
        profileImage: '',
        url: '',
        phone: ''
      },
      current: '',
      changeTo: '',
      repeatChangeTo: '',
      displayDialog: false,
      hideMessage: true,
      message: '',
      showEdit: false,
      resultMsg: null,
      showResult: false,
      counter: 1
    }
  },
  watch: {
    repeatPassword: function (val, oldVal) {
      console.log("Val.length: " + val.length + " New Pw Length: " + this.changeTo.length);
      if (val.length >= this.changeTo.length && val !== this.changeTo) {
        this.hideMessage = false;
        this.message = 'Passwörter sind nicht identisch!';
        console.log(oldVal);
      } else {
        this.hideMessage = true;
        this.message = '';
      }
    }
  },
  methods: {
    getCurrentUserProfile() {
      UserService.getUserById(this.currentUser)
          .then(user => {
            this.user.id = user.data._id;
            this.user.username = user.data.username;
            this.user.name = user.data.name;
            this.user.surname = user.data.surname;
            this.user.email = user.data.email;

            if (user.data.lastLoginTs) this.user.lastLoginTs = user.data.lastLoginTs;
            if (user.data.street) this.user.street = user.data.street;
            if (user.data.zipCode) this.user.zipCode = user.data.zipCode;
            if (user.data.city) this.user.city = user.data.city;
            if (user.data.profileImageId) this.user.profileImageId = user.data.profileImageId;
            if (user.data.phone) this.user.phone = user.data.phone;
            return UserService.getUserImageById(this.user);
          })
          .then(image => {
            console.log("getting image: " + image);
            // this.url = URL.createObjectURL(image);
            this.user.url = image.data;
          })
          .catch(err => {
            console.error(err);
          });
    },
    closeDialog() {
      this.showEdit = false;
      this.getCurrentUserProfile();
    },
    changePw() {
      if (this.current === '') {
        this.message = 'Das alte Passwort muss eingegeben werden';
        this.counter *= 1;
        this.hideMessage = false;
      } else {
        this.hideMessage = true;

        if (this.repeatChangeTo !== this.changeTo) {
          this.message = 'Der Check des neuen Passwortes war nicht efolgreich!';
          this.counter *= 1;
          this.hideMessage = false;
        } else {
          let data = {
            user_id: this.currentUser.id,
            current: this.current,
            changeTo: this.changeTo
          };

          UserService.changeAuth(data)
              .then(result => {
                if (result.data.success) {
                  this.resultMsg = {
                    severity: 'success',
                    message: 'Passwort erfolgreich geändert!'
                  };
                  this.showResult = true;
                } else {
                  this.resultMsg = {
                    severity: 'error',
                    message: 'Passwortänderung fehlgeschlagen!'
                  };
                  this.showResult = true;
                }
              })
              .catch(err => {
                this.resultMsg = {
                  severity: 'error',
                  message: err.message
                };
                this.showResult = true;
              });
        }
      }
    },
    openPwDialog() {
      this.current = '';
      this.changeTo = '';
      this.repeatChangeTo = '';
      this.showResult = false;
      this.displayDialog = true;
    },
    closePwDialog() {
      this.displayDialog = false;
    },
    openEditDialog(){
      this.showEdit = true;
    }
  },
  computed: {
    currentUser() {
      return this.$store.state.auth.user;
    },
    isAdmin() {
      if (this.currentUser && this.currentUser.roles) {
        return this.currentUser.roles.includes('ROLE_ADMIN');
      }
      return false;
    },
    dataUrl(){
      console.log(JSON.stringify(this.user));
      return 'data:image/png;base64,' + btoa(
          new Uint8Array(this.user.profileImage.data)
              .reduce((data, byte) => data + String.fromCharCode(byte), '')
      );
    }
  },
  mounted() {
    if (!this.currentUser) {
      this.$router.push('/login');
    } else {
      this.getCurrentUserProfile();
    }
  }
};
</script>

<style scoped>
.profile-avatar {
  width: 200px;
  height: 200px;
  border-radius: 50%;
  object-fit: cover;
  border: 3px solid #007bff;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
}

@media (max-width: 768px) {
  .profile-avatar {
    width: 150px;
    height: 150px;
  }
}
</style>

